import {formatPercentage} from '../../utils'

interface KpiCardProps {
  title: string
  value: number
  variant: 'primary' | 'muted' | 'success'
  showPlus?: boolean
  disableDynamicColors?: boolean
}

const KpiCard = ({
  title,
  value,
  variant,
  showPlus = false,
  disableDynamicColors = false,
}: KpiCardProps) => {
  const getCardClasses = () => {
    // Skip dynamic colors if disabled
    if (disableDynamicColors) {
      switch (variant) {
        case 'primary':
          return 'card border bg-light-primary'
        case 'success':
          return 'card border bg-light-success'
        default:
          return 'card border'
      }
    }

    // Override variant with dynamic color based on value
    if (value > 0) {
      return 'card border bg-light-success'
    } else if (value < 0) {
      return 'card border bg-light-danger'
    }

    // Fallback to original variant logic for zero values
    switch (variant) {
      case 'primary':
        return 'card border bg-light-primary'
      case 'success':
        return 'card border bg-light-success'
      default:
        return 'card border'
    }
  }

  const getTextClasses = () => {
    // Skip dynamic colors if disabled
    if (disableDynamicColors) {
      switch (variant) {
        case 'primary':
          return 'text-primary'
        case 'success':
          return 'text-success'
        default:
          return 'text-gray-900'
      }
    }

    // Override variant with dynamic color based on value
    if (value > 0) {
      return 'text-success'
    } else if (value < 0) {
      return 'text-danger'
    }

    // Fallback to original variant logic for zero values
    switch (variant) {
      case 'primary':
        return 'text-primary'
      case 'success':
        return 'text-success'
      default:
        return 'text-gray-900'
    }
  }

  const getTitleClasses = () => {
    // Skip dynamic colors if disabled
    if (disableDynamicColors) {
      switch (variant) {
        case 'primary':
          return 'text-primary fs-6 fw-bold mb-2'
        case 'success':
          return 'text-success fs-6 fw-bold mb-2'
        default:
          return 'text-muted fs-6 fw-bold mb-2'
      }
    }

    // Override variant with dynamic color based on value
    if (value > 0) {
      return 'text-success fs-6 fw-bold mb-2'
    } else if (value < 0) {
      return 'text-danger fs-6 fw-bold mb-2'
    }

    // Fallback to original variant logic for zero values
    switch (variant) {
      case 'primary':
        return 'text-primary fs-6 fw-bold mb-2'
      case 'success':
        return 'text-success fs-6 fw-bold mb-2'
      default:
        return 'text-muted fs-6 fw-bold mb-2'
    }
  }

  return (
    <div className='col-3'>
      <div className={getCardClasses()}>
        <div className='card-body p-6'>
          <div className='d-flex flex-column'>
            <div className={getTitleClasses()}>{title}</div>
            <div className={`fs-2x fw-bold ${getTextClasses()}`}>
              {showPlus && value >= 0 ? '+' : ''}
              {formatPercentage(value)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KpiCard
